// import { useEffect } from "react";

// const useInjectLiveChat = (isLoggedIn) => {
//   useEffect(() => {
//     if (!isLoggedIn) return;

//     // First script
//     const script1 = document.createElement("script");
//     script1.src = "https://intech-fzco1.odoo.com/im_livechat/loader/3";
//     script1.type = "text/javascript";
//     script1.defer = true;

//     script1.onload = () => {
//       // Inject second script only after first has loaded
//       const script2 = document.createElement("script");
//       script2.src = "https://intech-fzco1.odoo.com/im_livechat/assets_embed.js";
//       script2.type = "text/javascript";
//       script2.defer = true;
//       document.head.appendChild(script2);
//     };

//     document.head.appendChild(script1);

//     return () => {
//       document.head.removeChild(script1);
//       const existing2 = document.querySelector(
//         'script[src="https://intech-fzco1.odoo.com/im_livechat/assets_embed.js"]'
//       );
//       if (existing2) document.head.removeChild(existing2);
//     };
//   }, [isLoggedIn]);
// };

// export default useInjectLiveChat;

import { useEffect } from "react";

const useInjectLiveChat = (isLoggedIn) => {
  useEffect(() => {
    if (!isLoggedIn) return;

    // ---- preload font link ----
    const fontLink = document.createElement("link");
    fontLink.rel = "preload";
    fontLink.as = "font";
    fontLink.href = "https://intech-fzco1.odoo.com/im_livechat/odoo_ui_icons";
    fontLink.crossOrigin = "";
    document.head.appendChild(fontLink);

    // ---- @font-face style ----
    const style = document.createElement("style");
    style.innerHTML = `
      @font-face {
        font-family: odoo_ui_icons;
        src: url("https://intech-fzco1.odoo.com/im_livechat/odoo_ui_icons") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: block;
      }
    `;
    document.head.appendChild(style);

    // ---- first script ----
    const script1 = document.createElement("script");
    script1.src = "https://intech-fzco1.odoo.com/im_livechat/loader/3";
    script1.type = "text/javascript";
    script1.defer = true;

    script1.onload = () => {
      // ---- second script after first loads ----
      const script2 = document.createElement("script");
      script2.src = "https://intech-fzco1.odoo.com/im_livechat/assets_embed.js";
      script2.type = "text/javascript";
      script2.defer = true;
      document.head.appendChild(script2);
    };

    document.head.appendChild(script1);

    // ---- cleanup on logout/unmount ----
    return () => {
      [fontLink, style, script1].forEach((el) => {
        if (document.head.contains(el)) {
          document.head.removeChild(el);
        }
      });

      const script2 = document.querySelector(
        'script[src="https://intech-fzco1.odoo.com/im_livechat/assets_embed.js"]'
      );
      if (script2) document.head.removeChild(script2);
    };
  }, [isLoggedIn]);
};

export default useInjectLiveChat;

